export default __webpack_public_path__ + "static/media/close-btn.133884f4.svg";